"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _axios = _interopRequireDefault(require("axios"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _LanguageProvider = require("../../framework/LanguageProvider/LanguageProvider.index");

var _ResponsiveProvider = require("../../framework/ResponsiveProvider/ResponsiveProvider.index");

var _ErrorVisualizer = _interopRequireDefault(require("../ErrorVisualizer/ErrorVisualizer.index"));

var _ErrorVisualizer2 = require("../ErrorVisualizer/ErrorVisualizer.options");

var _Icon = _interopRequireDefault(require("../Icon/Icon.index"));

var _LiquidPixelVisualizer = _interopRequireDefault(require("../LiquidPixelVisualizer/LiquidPixelVisualizer.index"));

var _S3Visualizer = _interopRequireDefault(require("../S3Visualizer/S3Visualizer.index"));

var _Visualizer = require("./Visualizer.states");

var _Visualizer2 = require("./Visualizer.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var choiceValuedTypes = ['Height', 'Width'];
var urlParams = new URLSearchParams(window.location.search);

var optionsListChanged = function optionsListChanged(currOptions, prevOptions) {
  var vAreEqual = true;

  if (prevOptions && currOptions) {
    var oldOptions = prevOptions.map(function (x) {
      return "".concat(x.optionId, "-").concat(x.choiceId, "-").concat(x.choiceValue);
    }).toString();
    var newOptions = currOptions.map(function (x) {
      return "".concat(x.optionId, "-").concat(x.choiceId, "-").concat(x.choiceValue);
    }).toString();
    vAreEqual = vAreEqual && oldOptions === newOptions;
  } else if (!prevOptions && currOptions || prevOptions && !currOptions) {
    vAreEqual = false;
  }

  return !vAreEqual;
};

var determineViewer = function determineViewer(state) {
  var _urlParams$get;

  if ([_Visualizer.INITIALIZED, _Visualizer.VIS_FAILED].includes(state)) {
    return {
      viewer: _ErrorVisualizer["default"],
      errorToDisplay: state === _Visualizer.INITIALIZED ? _ErrorVisualizer2.BLANK_FILE : _ErrorVisualizer2.NOT_AVAILABLE_FILE
    };
  } // This no longer Changes between the S3 and LP visualizer due to issues with the LP Visualizer.
  // This is left as an example of the intended behaviour of this component.
  // If the LP viuewer issues are resolved it can be re-enabled here.


  var RenderedViewer =
  /* chain ? LiquidPixelVisualizer : */
  _S3Visualizer["default"];
  var viewOverride = (_urlParams$get = urlParams.get('viewOverride')) === null || _urlParams$get === void 0 ? void 0 : _urlParams$get.toLowerCase();

  switch (viewOverride) {
    case 'lpzoom':
      RenderedViewer = _LiquidPixelVisualizer["default"];
      break;

    case 'image':
      RenderedViewer = _S3Visualizer["default"];
      break;

    default:
      break;
  }

  return {
    viewer: RenderedViewer,
    errorToDisplay: null
  };
};

var Visualizer = function Visualizer(_ref) {
  var _theme$visualizer2, _theme$visualizer2$_s;

  var apiCallback = _ref.apiCallback,
      allowMinimizationActions = _ref.allowMinimizationActions,
      allowZoomActions = _ref.allowZoomActions,
      baseUrl = _ref.baseUrl,
      caption = _ref.caption,
      captionAlignment = _ref.captionAlignment,
      options = _ref.options,
      className = _ref.className,
      imageAlternateText = _ref.imageAlternateText,
      onMaximize = _ref.onMaximize,
      onMinimize = _ref.onMinimize,
      productId = _ref.productId,
      siteId = _ref.siteId,
      showEmptyVisualization = _ref.showEmptyVisualization,
      minimizeEnabled = _ref.minimizeEnabled,
      theme = _ref.theme,
      visualizationApiUrl = _ref.visualizationApiUrl;

  var _useBreakpoint = (0, _ResponsiveProvider.useBreakpoint)(),
      isLarge = _useBreakpoint.isLarge;

  var optionRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(_Visualizer.INITIALIZED),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewerState = _useState2[0],
      setViewerState = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isMinimized = _useState4[0],
      setIsMinimized = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      imageUrl = _useState8[0],
      setImageUrl = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      chain = _useState10[0],
      setChain = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      top = _useState12[0],
      setTop = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      zoomEnabled = _useState14[0],
      setZoomEnabled = _useState14[1];

  var shouldEnableMinimization = (0, _react.useMemo)(function () {
    return minimizeEnabled && (showEmptyVisualization || viewerState === _Visualizer.VISUALIZING);
  }, [minimizeEnabled, showEmptyVisualization, viewerState]);

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      showInstructions = _useState16[0],
      setShowInstructions = _useState16[1];

  var shouldShowCaption = (0, _react.useMemo)(function () {
    return viewerState === _Visualizer.VISUALIZING && isLarge && caption;
  }, [caption, isLarge, viewerState]);

  var _useContext = (0, _react.useContext)(_LanguageProvider.LanguageContext),
      translate = _useContext.translate;

  (0, _react.useEffect)(function () {
    optionRef.current = options;
  });
  var prevOptions = optionRef.current;

  var toggleInstructions = function toggleInstructions() {
    setShowInstructions(true);
    setTimeout(function () {
      return setShowInstructions(false);
    }, 1000);
  };

  var toggleZoom = function toggleZoom() {
    setZoomEnabled(function (isZoomEnabled) {
      if (!isZoomEnabled) {
        toggleInstructions();
      }

      return !isZoomEnabled;
    });
  }; // This function currently only handles passing viewer errors along.
  // It is expected to handle and state changes created by the viewer.


  var updateVisState = function updateVisState(visState) {
    var visualized = visState.visualized,
        loaded = visState.loaded; // If explicitly false

    if (visualized !== undefined && visualized !== null && !visualized) {
      setViewerState(_Visualizer.VIS_FAILED);
      setZoomEnabled(false);
      if (apiCallback && !visState.visualized) apiCallback({
        data: {
          Chain: null,
          Url: null
        }
      });
    }

    if (loaded !== undefined && loaded !== null) {
      setIsLoading(!loaded);
    }
  }; // This intentionally manages it's own update routine to avoid update loops from long dependency lists
  // eslint-disable-next-line react-hooks/exhaustive-deps


  (0, _react.useEffect)(function () {
    // If we call the api without h/w we may end up in a bad state for LP.
    // We also only want to call if options have changed.
    if (options && options.length > 0 && optionsListChanged(options, prevOptions) && siteId && productId) {
      var optionDetails = options.map(function (option) {
        return {
          o: option.optionId,
          c: option.choiceId,
          cv: choiceValuedTypes.includes(option.internalName) ? option.choiceValue : null,
          internalName: option.internalName
        };
      });
      var visMode = urlParams.get('visMode');
      var optimizedPayload = {
        ProductId: productId,
        SiteId: siteId,
        OptionDetails: optionDetails,
        visMode: visMode
      };
      setIsLoading(true);

      _axios["default"].post(visualizationApiUrl, optimizedPayload).then(function (res) {
        var _res$data = res.data,
            Chain = _res$data.Chain,
            Url = _res$data.Url; // No change, no update

        if (Url === imageUrl && Chain === chain) {
          setIsLoading(false);
          return;
        }

        if (apiCallback) apiCallback(res);

        if (Url === '') {
          setIsLoading(false);
          setViewerState(_Visualizer.INITIALIZED);
        } else {
          setViewerState(_Visualizer.VISUALIZING);
          setImageUrl(Url);
          setChain(Chain);
          setZoomEnabled(false);
        }
      })["catch"](function () {
        setViewerState(_Visualizer.VIS_FAILED);
        setImageUrl(null);
        setChain(null);
        setZoomEnabled(false);
        if (apiCallback) apiCallback({
          data: {
            Chain: null,
            Url: null
          }
        });
      });
    }
  });
  var actionButtons = (0, _react.useMemo)( // eslint-disable-next-line no-underscore-dangle
  function () {
    var _theme$visualizer, _theme$visualizer$_se;

    return (theme === null || theme === void 0 ? void 0 : (_theme$visualizer = theme.visualizer) === null || _theme$visualizer === void 0 ? void 0 : (_theme$visualizer$_se = _theme$visualizer._settings) === null || _theme$visualizer$_se === void 0 ? void 0 : _theme$visualizer$_se.actionButtons) || 'tertiary';
  }, // eslint-disable-next-line no-underscore-dangle
  [theme === null || theme === void 0 ? void 0 : (_theme$visualizer2 = theme.visualizer) === null || _theme$visualizer2 === void 0 ? void 0 : (_theme$visualizer2$_s = _theme$visualizer2._settings) === null || _theme$visualizer2$_s === void 0 ? void 0 : _theme$visualizer2$_s.actionButtons]);
  var handleVisualizerTopPosition = (0, _debounce["default"])(function () {
    setTop(window.scrollY < 130 ? null : 16);
  }, 100);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', handleVisualizerTopPosition);
    return function () {
      return window.removeEventListener('scroll', handleVisualizerTopPosition);
    };
  }, [handleVisualizerTopPosition]);
  var toggleMinimized = (0, _react.useCallback)(function () {
    return setIsMinimized(function (current) {
      if (!current) {
        setZoomEnabled(false);
        onMinimize();
      } else {
        onMaximize();
      }

      return !current;
    });
  }, [onMinimize, onMaximize]);

  var _determineViewer = determineViewer(viewerState),
      RenderedViewer = _determineViewer.viewer,
      errorToDisplay = _determineViewer.errorToDisplay;

  return /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledVisualizer, {
    className: className,
    isMinimized: isMinimized,
    shouldEnableMinimization: shouldEnableMinimization,
    top: top
  }, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledVisualizerRatioBox, {
    ratio: {
      width: 35,
      height: 31
    }
  }, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledZoomInstructions, {
    visible: showInstructions
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "drag",
    size: "original",
    color: "white"
  }), /*#__PURE__*/_react["default"].createElement("p", null, translate('Drag Image'))), /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledVisualizerWrapper, null, viewerState === _Visualizer.VISUALIZING && !isLoading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMinimized && shouldEnableMinimization && allowMinimizationActions ? /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledZoomOutButton, {
    color: actionButtons,
    onClick: toggleMinimized
  }, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledRatioBox, null, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledZoomOut, null))) : /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledActions, null, shouldEnableMinimization && allowMinimizationActions && /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledActionItem, null, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledZoomButton, {
    color: actionButtons,
    label: translate('minimize', _LanguageProvider.LangCasing.cap),
    size: "small",
    onClick: toggleMinimized
  })), allowZoomActions && /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledActionItem, null, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledZoomButton, {
    color: actionButtons,
    label: zoomEnabled ? translate('Zoom Out') : translate('Zoom In'),
    size: "small",
    onClick: toggleZoom
  })))), /*#__PURE__*/_react["default"].createElement(RenderedViewer, {
    baseUrl: baseUrl,
    baseImageUrl: imageUrl,
    chain: chain,
    errorToDisplay: errorToDisplay,
    imageAlternateText: imageAlternateText,
    minimized: isMinimized,
    updateZoom: setZoomEnabled,
    zoomEnabled: zoomEnabled,
    visualizationCallback: updateVisState
  }), /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledLoadArea, {
    isLoading: isLoading
  }, /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledLoadSpinner, null))), shouldShowCaption && /*#__PURE__*/_react["default"].createElement(_Visualizer2.StyledCaption, {
    alignment: captionAlignment
  }, caption)));
};

Visualizer.defaultProps = {
  apiCallback: _noop2["default"],
  allowMinimizationActions: false,
  allowZoomActions: false,
  baseUrl: 'https://www.blinds.com/is/image/blinds',
  caption: null,
  captionAlignment: 'left',
  options: [],
  className: null,
  productId: null,
  showEmptyVisualization: false,
  siteId: null,
  minimizeEnabled: false,
  onMinimize: _noop2["default"],
  onMaximize: _noop2["default"],
  visualizationApiUrl: '/api/visualization/url'
};
Visualizer.propTypes = {
  /** Image alternate text */
  imageAlternateText: _propTypes.string.isRequired,

  /** Base url used to serve images to the visualizer */
  baseUrl: _propTypes.string,

  /** Text to be displayed at the bottom of the visualizer (hidden on small devices) */
  caption: _propTypes.string,

  /** Alignment of the caption below the visualizer (left, center, right) */
  captionAlignment: _propTypes.string,

  /** List of the currently selected otions, and their choice data. */
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    optionId: _propTypes.number,
    choiceId: _propTypes.number,
    internalName: _propTypes.string,
    choiceValue: _propTypes.string
  })),

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Product ID */
  productId: _propTypes.number,

  /** If True visualization will show while minimized even without a vis image */
  showEmptyVisualization: _propTypes.bool,

  /** Site ID */
  siteId: _propTypes.number,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** If true, the visualizer will show on PIP (Picture-in-Picture) mode
   * Using components can use this to control min state when size changes occur.
   */
  minimizeEnabled: _propTypes.bool,

  /** If true, the visualizer will show Minimize and Maximize buttons. */
  allowMinimizationActions: _propTypes.bool,

  /** If true, the visualizer will show Zoom buttons. */
  allowZoomActions: _propTypes.bool,

  /** Callback function when the Liquid Pixel visualizer is minimized */
  onMinimize: _propTypes.func,

  /** Callback function when the Liquid Pixel visualizer is maximized */
  onMaximize: _propTypes.func,

  /** Return API response to container so that the container can update UI */
  apiCallback: _propTypes.func,

  /** Url for the component to call with selected Options and Choices that are passed in */
  visualizationApiUrl: _propTypes.string
};

function areEqual(prevProps, nextProps) {
  var vAreEqual = true;
  vAreEqual = vAreEqual && !optionsListChanged(nextProps.options && prevProps.options);
  vAreEqual = vAreEqual && prevProps.siteId === nextProps.siteId;
  vAreEqual = vAreEqual && prevProps.minimizeEnabled === nextProps.minimizeEnabled;
  vAreEqual = vAreEqual && prevProps.allowMinimizationActions === nextProps.allowMinimizationActions;
  vAreEqual = vAreEqual && prevProps.allowZoomActions === nextProps.allowZoomActions;
  vAreEqual = vAreEqual && prevProps.caption === nextProps.caption;
  return vAreEqual;
}

Visualizer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Visualizer",
  "props": {
    "apiCallback": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Return API response to container so that the container can update UI",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "allowMinimizationActions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the visualizer will show Minimize and Maximize buttons.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "allowZoomActions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the visualizer will show Zoom buttons.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "baseUrl": {
      "defaultValue": {
        "value": "'https://www.blinds.com/is/image/blinds'",
        "computed": false
      },
      "description": "Base url used to serve images to the visualizer",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "caption": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Text to be displayed at the bottom of the visualizer (hidden on small devices)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "captionAlignment": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "Alignment of the caption below the visualizer (left, center, right)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "List of the currently selected otions, and their choice data.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "optionId": {
              "name": "number",
              "required": false
            },
            "choiceId": {
              "name": "number",
              "required": false
            },
            "internalName": {
              "name": "string",
              "required": false
            },
            "choiceValue": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "productId": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Product ID",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "showEmptyVisualization": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If True visualization will show while minimized even without a vis image",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "siteId": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Site ID",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "minimizeEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the visualizer will show on PIP (Picture-in-Picture) mode\r\nUsing components can use this to control min state when size changes occur.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onMinimize": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Callback function when the Liquid Pixel visualizer is minimized",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMaximize": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Callback function when the Liquid Pixel visualizer is maximized",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "visualizationApiUrl": {
      "defaultValue": {
        "value": "'/api/visualization/url'",
        "computed": false
      },
      "description": "Url for the component to call with selected Options and Choices that are passed in",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "imageAlternateText": {
      "description": "Image alternate text",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = /*#__PURE__*/(0, _react.memo)((0, _styledComponents.withTheme)(Visualizer), areEqual);

exports["default"] = _default;